import React, { useState } from "react";
import PropTypes from "prop-types";

export const Form = ({
  name,
  value,
  onChange: onChangeProp,
  type = "",
  label = "",
  placeholder = "",
  className = "",
  errorResponse = "Please match the requested format.",
}) => {
  const [hasError, setHasError] = useState(null);
  const fieldId = `field-${name}`;

  let pattern;
  if (type === "email") pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (type === "number") pattern = /^[0-9]{10}$/;

  const handleChange = (event) => {
    const target = {
      target: {
        name,
        value: event.target.value,
      },
    };

    if (type === "email") {
      if (!pattern.test(event.target.value)) setHasError(errorResponse);
      else setHasError(null);
    }

    if (type === "number") {
      if (event.target.validity.valid) onChangeProp(target);
      if (!pattern.test(event.target.value)) {
        setHasError(errorResponse);
      } else {
        setHasError(null);
        onChangeProp(target);
      }
    } else {
      onChangeProp(target);
    }
  };

  const baseInputClass = [
    "w-full p-3.5 font-normal text-slate-800 rounded-lg border border-slate-200",
    "focus:outline-none focus:ring-2 focus:ring-maroon-100 focus:border-maroon-400 transition-colors",
  ].join(" ");

  return (
    <div className={["flex flex-col mb-5 mx-2 lg:mx-3 w-full sm:w-72", className].join(" ")}>
      <label htmlFor={fieldId} className="mb-1.5 text-sm font-medium text-slate-700">
        {label || placeholder}
      </label>
      {type === "textarea" ? (
        <textarea
          id={fieldId}
          name={name}
          placeholder={placeholder}
          value={value}
          className={`${baseInputClass} sm:w-full`}
          onChange={handleChange}
          rows="6"
          required
        />
      ) : (
        <input
          id={fieldId}
          name={name}
          type={type}
          placeholder={placeholder}
          pattern={type === "number" ? pattern : undefined}
          value={value}
          className={baseInputClass}
          onChange={handleChange}
          required
        />
      )}
      {hasError && (
        <span role="alert" className="mt-1.5 text-sm text-red-600">
          {hasError}
        </span>
      )}
    </div>
  );
};

Form.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  errorResponse: PropTypes.string,
};
